export default __webpack_public_path__ + "static/intercom-3b89efb8ce0cb09accf38e277519130d.svg";